import React from "react";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { useReceivableModel } from "../receivableModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";

export const DataBox = () => {
    const { exportReceivable } = useReceivableModel();

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.R_A_EX}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => exportReceivable()}
            >导出</Button>
        </YhAuth>
    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}